import { CommunicationType, StageNodeData } from '@bandido/shared/types';
import { useUploadIVRAudio } from '../queries';

interface UseFileUploadProps {
  selectedStageId?: string;
  onStageChange: (id: string, data: Partial<StageNodeData>) => void;
  communicationType?: CommunicationType;
}

export const useFileUpload = ({ selectedStageId, onStageChange, communicationType }: UseFileUploadProps) =>
  useUploadIVRAudio({
    onSuccess: (url) => {
      if (selectedStageId && url) {
        const isRecording = communicationType === CommunicationType.AUDIO_RECORD;

        onStageChange(selectedStageId, {
          ...(isRecording ? { audioUrl: url } : { fileUrl: url }),
          communicationType: communicationType || CommunicationType.AUDIO_FILE,
        });
      }
    },
    onError: () => {},
  });
